import { render, staticRenderFns } from "./PendignPage.vue?vue&type=template&id=585c93f5&scoped=true&"
import script from "./PendignPage.vue?vue&type=script&lang=js&"
export * from "./PendignPage.vue?vue&type=script&lang=js&"
import style0 from "./PendignPage.vue?vue&type=style&index=0&id=585c93f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c93f5",
  null
  
)

export default component.exports